import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { StockTrackerPage, StatsPage } from './pages/';
import './styles.css';

function App() {
  return (
    <Router basename="/stocktracker">
      <Routes>
        <Route path="/" element={<StockTrackerPage />} />
        <Route path="/stats" element={<StatsPage />} />
      </Routes>
    </Router>
  );
}



export default App;